import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Cobertura', href: '#cobertura' },
  { label: 'Galería', href: '#galeria' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-yakis-white/95 backdrop-blur-md shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="section-container flex items-center justify-between">
        {/* Logo */}
        <h1 className="m-0 p-0 leading-none">
          <a href="#inicio" onClick={() => scrollTo('#inicio')} className="flex items-center gap-3 group">
            <img
              src="https://public.readdy.ai/ai/img_res/61a74797-87df-4251-bf99-e770eda51805.png"
              alt="Yakis Transporte Empresarial"
              className="w-10 h-10 md:w-12 md:h-12 object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </a>
        </h1>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.href);
              }}
              className="text-sm font-medium text-yakis-silver hover:text-yakis-gold transition-colors duration-300 relative group"
            >
              {link.label}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yakis-gold transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        {/* CTA Desktop */}
        <div className="hidden md:block">
          <a
            href="#cotizacion"
            onClick={(e) => {
              e.preventDefault();
              scrollTo('#cotizacion');
            }}
            className="btn-primary text-sm py-2.5 px-5"
          >
            Cotizar Ahora
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors hover:bg-yakis-navy/5"
          aria-label="Menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-yakis-navy`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-yakis-white/98 backdrop-blur-md border-t border-yakis-cream">
          <div className="section-container py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="py-3 px-4 text-sm font-medium text-yakis-silver hover:text-yakis-gold hover:bg-yakis-navy/5 rounded-lg transition-all duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#cotizacion"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#cotizacion');
              }}
              className="btn-primary text-sm py-3 mt-2 text-center"
            >
              Cotizar Ahora
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}